// Modules
import { reduxForm, Field } from 'redux-form';
import React from 'react';
import _ from 'lodash';

import { CompanySelect } from 'components/forms/selects';
import { TextAreaInput, TextInput, IntegerInput } from 'components/forms/form-elements';
import { Form } from 'components/forms/form-structure';
import { handleServerError } from 'utils/form-utils';
import requiredValidation from 'utils/required-validation';


// Component
function WorkOrderForm(props) {
  return (
    <Form preventAutoFocus onSubmit={props.handleSubmit} {..._.pick(props, ['submitting', 'error', 'submitFailed'])}>
      <Field component={TextInput} name="number" label="Work Order Number" />
      <Field component={TextAreaInput} name="description" label="Description" />
      <Field component={CompanySelect} name="company" label="Company" />
      <Field component={IntegerInput} name="estimatedHours" label="Estimated Hours" />
    </Form>
  );
}

export default reduxForm({
  form: 'work-order-form',
  validate: (values) => requiredValidation(['number', 'description'], values),
  onSubmitFail: handleServerError
})(WorkOrderForm);
